document.addEventListener("bundler:loaded", function (e) {
  setTimeout(() => {
    const selectedBundleItemsEl = document.querySelector(
      ".bndlr-mnm-second-container"
    );
    const selectedBundleToggleEl = document.querySelector(
      ".bndlr-mnm-selected-products-title.bndlr-toggle"
    );

    const allProducts = document.querySelectorAll(
      ".bndlr-product.bndlr-mix-and-match.bndlr-no-plus-sign"
    );

    const currentBundleEl = document.querySelector(
      ".bndlr-mnm-selected-products.bndlr-toggle"
    );

    if (selectedBundleItemsEl) {
      selectedBundleToggleEl.addEventListener("click", function (e) {
        selectedBundleItemsEl.classList.toggle("open");
      });
    }

    if (allProducts && currentBundleEl) {
      allProducts.forEach((product) => {
        product.addEventListener("click", function (e) {
          if (currentBundleEl.childNodes.length >= 2) {
            selectedBundleItemsEl.classList.add("open");
          }
        });
      });
    }
  }, 1500);
});
